const actions = {
    SET_DATA: 'employeeDocumentTypes/SET_DATA',
    GET_DATA: 'employeeDocumentTypes/GET_DATA',
};

export default actions
